import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAj4AhGEMRrFJaDR3p-uDvUxIrGaG9Ozys",
  authDomain: "mumu-mycompany.firebaseapp.com",
  projectId: "mumu-mycompany",
  storageBucket: "mumu-mycompany.firebasestorage.app",
  messagingSenderId: "999906991280",
  appId: "1:999906991280:web:c6964b1dc3fbbb7c946f75",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
auth.languageCode = navigator.language || "ja";
